import { connect } from 'react-redux'
import requestRemoveBookmark from '../../../sagas/requestRemoveBookmark'
import requestAddBookmark from '../../../sagas/requestAddBookmark'
import ActivityContent from './ActivityContent'
import { withBoardContext } from 'dataProviders/Board'

export default withBoardContext(connect(
  null,
  {
    requestAddBookmark,
    requestRemoveBookmark
  },
  null,
  {
    forwardRef: true
  }
)(ActivityContent))
